<template>
  <div class="card-container">
    <common-top-form
      ref="commonTopForm"
      selectShowPower="/shopactivationlook/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
      downloadPower="/shopactivationlook/PeopleExport"
      :showDownloadPower="true"
      @down="down"
      showDownloadPowerType="warning"
      :needCheck="needCheck"
      @check="handleTopCheck"
    >
      <el-form-item label="ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="月份">
        <el-date-picker
          v-model="formModel.date"
          type="month"
          value-format="yyyy-MM"
          format="yyyy-MM"
          placeholder="选择月"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="machinesId"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="商户名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="date"
        label="激活时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="examineMoney"
        label="交易量(元)"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="examineMoney2"
        label="剩余未达标交易量(元)"
        :formatter="formatterTableNumber"
        min-width="260"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="flag"
        label="激活标识"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{
          scope.row.flag == 1 ? "是" : "否"
        }}</template>
      </el-table-column>
      <el-table-column
        prop="flag"
        label="商户考核标识"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{
          scope.row.examineMoney2 == 0 && scope.row.flag == 1 ? "是" : "否"
        }}</template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "shopactivationlook",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      needCheck: true,
      formModel: {
        userId: "",
        date: "",
      },
      tableData: [],
      submitService: StatisticsService.shopactivationlookList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      const params = {
        userId: this.formModel.userId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        date: this.formModel.date,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        date: "",
      };
      this.page = this.$refs.commonTable.page;
      // this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
        this.needCheck = true;
      });
    },
    down() {
      if (!this.formModel.userId && !this.formModel.date) {
        this.showWarming("请输入 Id 和 月份");
        return;
      }
      this.needCheck = false;
      this.$refs.commonTopForm.submit();
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "export",
            "8883",
            "/statistics/machines-transaction/"
          )
        : "";
    },
    handleTopCheck() {
      if (!this.formModel.userId && !this.formModel.date) {
        this.showWarming("请输入 Id 和 月份");
        return;
      }

      this.needCheck = false;
      this.$refs.commonTopForm.submit();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Statistics/ShopActivationLook.vue